import { useJiraTemplateChoice } from "./use-jira-template-choice";

import {
    useCloudStatus,
    useSearchParameters,
    useUserSegmentationStatus
} from "./";
export type ConfirmationPageType =
    | "robots"
    | "tips"
    | "timeout"
    | "user-segmentation"
    | "jira-template-selection"
    | "error";

const useConfirmationPageType = (): ConfirmationPageType => {
    const { createCloudStatus } = useCloudStatus();
    const { products } = useSearchParameters();
    const { shouldShowUserSegmentationPage } =
        useUserSegmentationStatus(products);
    const { shouldShowJiraTemplateChoiceScreen } = useJiraTemplateChoice();

    if (shouldShowUserSegmentationPage) {
        return "user-segmentation";
    }

    if (shouldShowJiraTemplateChoiceScreen) {
        return "jira-template-selection";
    }

    switch (createCloudStatus) {
        case "error":
            return "error";
        case "timeout":
            return "timeout";
        default:
            if (products.some(includesBitbucketOrOpsGenie)) {
                return "robots";
            } else {
                if (products.length > 1 && products.some(includesJira)) {
                    return "tips";
                } else {
                    return "robots";
                }
            }
    }
};

export default useConfirmationPageType;

function includesBitbucketOrOpsGenie(text: string): boolean {
    return text.includes("bitbucket") || text.includes("opsgenie");
}

// We arent testing real product keys here, unlike what occurs in sign-up
function includesJira(text: string): boolean {
    return text.includes("jira");
}
